import React from 'react';
import { Link } from 'react-router-dom';

interface NavbarProps {
  isLoggedIn: boolean;
  userName: string;
  message?: string;
  onLogin: () => void;
  onRegister: () => void;
  onLogout: () => void;
  isLoading?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({
  isLoggedIn,
  userName,
  message = '',
  onLogin,
  onRegister,
  onLogout,
  isLoading = false
}) => {
  return (
    <div className="navbar">
      <div className="navbar-left">
        <Link to="/" className="app-title-link">
          <h1 className="app-title">Vocab Note</h1>
        </Link>
        <div className="nav-links">
          {isLoggedIn && (
            <>
              <Link to="/words" className="nav-link">Words</Link>
              <Link to="/learn" className="nav-link">Learn</Link>
            </>
          )}
        </div>
      </div>
      <div className="auth-section">
        {isLoading ? (
          <div className="auth-loading">
            <span className="loading-dot"></span>
            <span className="loading-dot"></span>
            <span className="loading-dot"></span>
          </div>
        ) : isLoggedIn ? (
          <Link to="/profile" className="nav-link profile-link">
            <span className="welcome-text">{userName}</span>
          </Link>
        ) : (
          <>
            <span className="api-status">{message}</span>
            <button 
              className="auth-button login-button" 
              onClick={onLogin}
            >
              Login
            </button>
            <button 
              className="auth-button register-button" 
              onClick={onRegister}
            >
              Register
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Navbar; 